module.exports = __webpack_public_path__ + "img/MEDIA046.a26dc9c5.jpg";